import React from 'react';

import { Label } from '@atlaskit/form/label/default';
import Select from '@atlaskit/select/default';

const SelectSingleExample = (): React.JSX.Element => (
	<>
		<Label htmlFor="single-select-example-legacy">What city do you live in?</Label>
		{/* eslint-disable-next-line @atlaskit/design-system/no-placeholder */}
		<Select
			inputId="single-select-example-legacy"
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
			className="single-select-legacy"
			classNamePrefix="react-select-legacy"
			options={[
				{ label: 'Adelaide', value: 'adelaide' },
				{ label: 'Brisbane', value: 'brisbane' },
				{ label: 'Canberra', value: 'canberra' },
				{ label: 'Darwin', value: 'darwin' },
				{ label: 'Hobart', value: 'hobart' },
				{ label: 'Melbourne', value: 'melbourne' },
				{ label: 'Perth', value: 'perth' },
				{ label: 'Sydney', value: 'sydney' },
			]}
			placeholder=""
		/>
	</>
);

export default SelectSingleExample;
